<template>
  <div>
    <top>
      <Icon slot="left" type="ios-arrow-back" @click="back" />
      <p slot="center"><fenximenu @now="reNow"></fenximenu></p
    ></top>
    <month ref="month" v-show="now == 1"></month>
    <year ref="year" v-show="now == 2"></year>
  </div>
</template>
<script>
import month from "./month.vue";
import year from "./year.vue";
import fenximenu from "./fenxiMenu.vue";
export default {
  components: {
    month,
    year,
    fenximenu,
  },
  data() {
    return {
      now: 1,
    };
  },
  methods: {
    reNow(v) {
      this.now = v;
      setTimeout(() => {
        if (v == 1) {
          this.$refs.month.getData();
        } else {
          this.$refs.year.getData();
        }
      }, 500);
    },
    back() {
      this.$router.push({ path: "/home" });
    },
  },
  mounted() {
    this.$refs.month.getData();
  },
};
</script>


// WEBPACK FOOTER //
// src/components/fenxi/feiyong/index.vue